(function () {
  /**
   * @param {HTMLElement} section
   */
  function clearSectionAnimationProps(section) {
    if (typeof gsap === 'undefined') return;
    gsap.set(
      section.querySelectorAll(
        '.inc2col__hero-char, .inc2col__hero-eyebrow, .inc2col__hero-tagline, .inc2col__deco-video'
      ),
      { clearProps: 'all' }
    );
  }

  /**
   * @param {HTMLElement} section
   * @param {HTMLElement | null} hero
   */
  function finishSection(section, hero) {
    clearSectionAnimationProps(section);
    section.classList.remove('inc2col--pending-deco-video');
    if (hero) hero.classList.add('inc2col__hero--ready');
  }

  function showFallback() {
    document.querySelectorAll('.inc2col').forEach(function (node) {
      var section = /** @type {HTMLElement} */ (node);
      var hero = section.querySelector('[data-inc2col-hero]');
      if (!hero) return;
      finishSection(section, /** @type {HTMLElement} */ (hero));
    });
  }

  function initInc2colHero() {
    if (typeof gsap === 'undefined') return false;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    document.querySelectorAll('.inc2col').forEach(function (node) {
      var section = /** @type {HTMLElement} */ (node);
      var hero = section.querySelector('[data-inc2col-hero]');

      if (!hero) return;

      var heroEl = /** @type {HTMLElement} */ (hero);

      if (heroEl.dataset.inc2colAnimated === 'true') return;
      heroEl.dataset.inc2colAnimated = 'true';

      var decoVideo = section.querySelector('.inc2col__deco-video');

      if (reduceMotion) {
        finishSection(section, heroEl);
        return;
      }

      var eyebrow = heroEl.querySelector('.inc2col__hero-eyebrow');
      var title = heroEl.querySelector('.inc2col__hero-title');
      var buildLine = heroEl.querySelector('.inc2col__hero-title-line--build');
      var revealLine = heroEl.querySelector('.inc2col__hero-title-line--reveal');
      var tagline = heroEl.querySelector('.inc2col__hero-tagline');
      var oChars = title ? title.querySelectorAll('.inc2col__hero-char--o') : [];
      var line1Other = buildLine
        ? buildLine.querySelectorAll('.inc2col__hero-char:not(.inc2col__hero-char--o):not(.inc2col__hero-char--space)')
        : [];
      var line2Other = revealLine
        ? revealLine.querySelectorAll('.inc2col__hero-char:not(.inc2col__hero-char--o):not(.inc2col__hero-char--space)')
        : [];
      var animatedTargets = heroEl.querySelectorAll(
        '.inc2col__hero-char, .inc2col__hero-eyebrow, .inc2col__hero-tagline'
      );

      gsap.set(animatedTargets, { clearProps: 'all' });
      heroEl.classList.remove('inc2col__hero--ready');
      heroEl.style.visibility = 'visible';

      if (decoVideo) {
        gsap.set(decoVideo, {
          autoAlpha: 0,
          scale: 1.05,
          transformOrigin: '50% 50%'
        });
      }

      var tl = gsap.timeline({
        defaults: { ease: 'power3.out' },
        onComplete: function () {
          finishSection(section, heroEl);
        }
      });

      if (eyebrow) {
        tl.fromTo(
          eyebrow,
          { autoAlpha: 0, y: 12 },
          { autoAlpha: 1, y: 0, duration: 0.55, ease: 'power2.out' }
        );
      }

      if (oChars.length) {
        tl.fromTo(
          oChars,
          { autoAlpha: 0, scale: 0, transformOrigin: '50% 50%' },
          {
            autoAlpha: 1,
            scale: 1,
            duration: 0.62,
            ease: 'back.out(1.75)',
            stagger: 0
          },
          eyebrow ? '-=0.1' : 0
        );

        tl.to(
          oChars,
          {
            scale: 1.06,
            duration: 0.16,
            ease: 'power1.out',
            stagger: 0,
            yoyo: true,
            repeat: 1
          },
          '>-0.05'
        );
      }

      if (line1Other.length) {
        tl.fromTo(
          line1Other,
          {
            autoAlpha: 0,
            x: function (/** @type {number} */ index) {
              return index % 2 === 0 ? -24 : 24;
            }
          },
          {
            autoAlpha: 1,
            x: 0,
            duration: 0.5,
            stagger: 0.03,
            ease: 'power3.out'
          },
          oChars.length ? '-=0.2' : eyebrow ? '-=0.15' : 0
        );
      }

      if (line2Other.length) {
        tl.fromTo(
          line2Other,
          { yPercent: 120, autoAlpha: 0 },
          {
            yPercent: 0,
            autoAlpha: 1,
            duration: 0.95,
            stagger: 0.035,
            ease: 'power4.out'
          },
          '-=0.3'
        );
      }

      var taglinePosition = '-=0.55';

      if (tagline) {
        tl.fromTo(
          tagline,
          {
            autoAlpha: 0,
            y: isMobile ? 10 : 14,
            filter: isMobile ? 'none' : 'blur(8px)'
          },
          {
            autoAlpha: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 0.7,
            ease: 'power2.out'
          },
          taglinePosition
        );
      }

      if (decoVideo) {
        tl.fromTo(
          decoVideo,
          { autoAlpha: 0, scale: 1.05 },
          {
            autoAlpha: 1,
            scale: 1,
            duration: 0.85,
            ease: 'power3.out',
            onStart: function () {
              section.classList.remove('inc2col--pending-deco-video');
            }
          },
          tagline ? '<' : taglinePosition
        );
      } else {
        section.classList.remove('inc2col--pending-deco-video');
      }
    });

    return true;
  }

  function boot() {
    if (initInc2colHero()) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (initInc2colHero() || attempts >= 40) {
        window.clearInterval(timer);
        if (attempts >= 40) showFallback();
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-inc2col-hero]').forEach(function (node) {
      var hero = /** @type {HTMLElement} */ (node);
      delete hero.dataset.inc2colAnimated;
    });
    boot();
  });
})();
